<template lang="pug">
.UserPanel
  .Header-select(
    v-click-outside='hideUserMenu',
    @click='toggleUserMenu',
    @mouseover.stop='toggleUserMenuHelperText',
    @mouseout.stop='helperText = null'
  )
    i.Icon.IconUser
    i.Icon.IconChevronDown
  .UserPanel-dropdown.Dropdown.Dropdown--right(v-if='showUserMenu')
    .UserPanel-user-name.Dropdown-item(v-if='userName')
      .UserPanel-user-name-text
        | {{ userName }}
      .UserPanel-departments(v-if='userDepartments')
        .UserPanel-departments-item(
          v-for='department in userDepartments',
          :key='department.id',
          :title='department.name'
        )
          | {{ department.name }}
    .Dropdown-item(
      @click.stop.prevent='toggleTheme',
      @touchstart.stop.prevent='toggleTheme'
    )
      | {{ themeButtonText }}
    a.Dropdown-item(
      v-if='documentationLink',
      :href='documentationLink',
      target='_blank',
      @click.stop='hideUserMenu',
      @touchstart.stop=''
    )
      | Помощь
    .Dropdown-item(
      v-if='token',
      @click.stop='logout',
      @touchstart.stop='logout'
    )
      | Выход
    router-link.Dropdown-item(
      v-else,
      :to='{ name: "login" }',
      @click.native.stop='',
      @touchstart.native.stop=''
    )
      | Вход
</template>

<script>
import { env } from '../../config'
import ClickOutside from 'vue-click-outside'
import helpertext from '@/mixins/helpertext'

export default {
  name: 'UserPanel',

  mixins: [helpertext],

  directives: {
    ClickOutside
  },

  data() {
    return {
      showUserMenu: false
    }
  },

  computed: {
    /**Ссылка на документацию из конфига приложения */
    documentationLink() {
      return env.VUE_APP_MW_DOC || null
    },

    userName() {
      return this.$store.getters.userData.name
    },

    userDepartments() {
      const userDepartments = this.$store.getters.userData.departments

      if (!Array.isArray(userDepartments) || userDepartments.length === 0) {
        return null
      }

      return userDepartments
    },

    theme() {
      return this.$store.getters.theme
    },

    themeButtonText() {
      return this.theme === 'default' ? 'Включить темную тему' : 'Включить светлую тему'
    },

    token() {
      return this.$store.getters.token
    }
  },

  methods: {
    hideUserMenu() {
      this.showUserMenu = false
    },

    logout() {
      this.$store.dispatch('logout')
      this.showUserMenu = false
    },

    toggleTheme() {
      const newTheme = this.theme === 'default' ? 'dark' : 'default'
      this.$store.dispatch('setTheme', newTheme)
      this.showUserMenu = false
    },

    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu
      this.toggleUserMenuHelperText()
    },

    toggleUserMenuHelperText() {
      this.helperText = this.showUserMenu ? 'Свернуть меню пользователя' : 'Развернуть меню пользователя'
    }
  }
}
</script>

<style lang="scss">
@import '~base';

#app .UserPanel {
  --headerText: #{$black5};
  --headerNavItemHoverBg: #{$grey-light};
  --userIconColor: #{$black5};
}

#app[data-theme='dark'] .UserPanel {
  --headerText: #{$white3};
  --headerNavItemHoverBg: #{$black2};
  --userIconColor: #{$grey1};
}

.UserPanel {
  &-user-name {
    cursor: default;
  }

  &-departments {
    opacity: 0.4;
    border-top: 0;
    cursor: default;
    line-height: 14px;
    font-size: 12px;
    margin-top: 8px;
  }

  &-departments-item {
    max-width: 200px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .Icon {
    font-size: 18px;
    color: var(--secondaryText);
    margin-left: 7px;

    &:first-child {
      margin-left: 0;
    }
  }

  .IconUser {
    margin-left: 0;
    font-size: 20px;
    color: var(--userIconColor);
  }

  &-dropdown {
    &.Dropdown {
      padding: 0;

      .Dropdown-item {
        display: block;
        padding: 16px;
        line-height: 14px;
        color: var(--headerText);
        text-decoration: none;

        &:hover {
          background-color: var(--headerNavItemHoverBg);
        }

        &.UserPanel-user-name.Dropdown-item {
          &:hover {
            background-color: transparent;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserPanel.vue